(function () {
  const hostSelector = 'gty-whatsapp-chat-button';
  const styleId = 'bsc-whatsapp-overlap-fix';

  function installWidgetFix() {
    const host = document.querySelector(hostSelector);
    const shadow = host && host.shadowRoot;
    if (!shadow) return false;

    if (!shadow.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .gty-wacb-wrapper {
          left: 12px !important;
          bottom: 16px !important;
          transition: bottom 180ms ease !important;
        }

        .gty-wacb-button {
          width: 46px !important;
          min-width: 46px !important;
          padding-right: 0 !important;
          padding-left: 0 !important;
          border-radius: 50% !important;
        }

        .gty-wacb-button-logo {
          margin-right: 0 !important;
        }

        .gty-wacb-button-text {
          display: none !important;
        }

        @media (min-width: 768px) {
          .gty-wacb-wrapper {
            bottom: 74px !important;
          }
        }

        :host([data-bsc-sticky-buy-visible]) .gty-wacb-wrapper {
          bottom: 88px !important;
        }
      `;
      shadow.appendChild(style);
    }

    const button = shadow.querySelector('.gty-wacb-button');
    if (button) button.setAttribute('aria-label', 'Chat with BSC on WhatsApp');

    const stickyBuy = document.querySelector('[data-bsc-sticky-buy]');
    const syncStickyState = function () {
      host.toggleAttribute(
        'data-bsc-sticky-buy-visible',
        Boolean(stickyBuy && stickyBuy.classList.contains('visible')),
      );
    };

    syncStickyState();

    if (stickyBuy && !stickyBuy.dataset.bscWhatsAppObserved) {
      stickyBuy.dataset.bscWhatsAppObserved = 'true';
      new MutationObserver(syncStickyState).observe(stickyBuy, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    return true;
  }

  if (installWidgetFix()) return;

  const observer = new MutationObserver(function () {
    if (installWidgetFix()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
